import React, { useEffect, useState } from 'react';
import { Column } from '@tanstack/react-table';
import { isEmpty, isNumber } from 'lodash';
import { LocationAutocomplete } from 'modules/form';
import { NumberInput } from 'modules/ui/components/new/NumberInput';
import { TGetGeoCodedAddressResponse } from 'types';

import styles from './LocationRadiusFilter.module.scss';

export interface ILocationRadiusFilterProps {
    column: Column<any, unknown>;
}

export const LocationRadiusFilter = ({ column }: ILocationRadiusFilterProps) => {
    const [valuesInjected, setValuesInjected] = useState(false);

    const filterValue = column.getFilterValue();
    const [radius, setRadius] = useState<number | undefined>(undefined);
    const [selectedLocation, setSelectedLocation] = useState<TGetGeoCodedAddressResponse[number] | null>(null);

    useEffect(() => {
        const { radius, ...location } = JSON.parse((column.getFilterValue() as string) || '{}');
        setRadius(radius || undefined);
        setSelectedLocation(isEmpty(location) ? null : location);
        setValuesInjected(true);
    }, [column, filterValue]);

    useEffect(() => {
        if (!valuesInjected) return;

        if (!selectedLocation || !isNumber(radius)) {
            return column.setFilterValue(undefined);
        }

        column.setFilterValue(
            JSON.stringify({
                ...selectedLocation,
                radius,
            }),
        );
    }, [radius, selectedLocation, valuesInjected, column]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.inputWrapper}>
                <LocationAutocomplete onSelect={setSelectedLocation} selected={selectedLocation} />
            </div>
            <div className={styles.inputWrapper}>
                <NumberInput value={radius} onChange={setRadius} />
            </div>
        </div>
    );
};
